<div class="visible-lg">
  <div class="flex-container">
    <div class="bmw-bulletin-container flex-60">
      <div class="flex-container space-between center">
        <div class="bmw-bulletin-title">
          Manage Users
        </div>
      </div>
      <div class="bmw-profile-content">
        <div class="bmw-user-info-title">Personal Info</div>
        <form [formGroup]='userForm' (ngSubmit)="onFormSubmit()">
          <label for="firstName">First Name *</label>
          <br>
          <input type="text" placeholder="Enter First Name" required name="firstName" id="firstName" [formControl]="firstName">
          <small *ngIf="userForm.get('firstName').hasError('required') && userForm.get('firstName').touched">Required</small>
          <br>
          <label for="lastName">Last Name *</label>
          <br>
          <input type="text" placeholder="Enter Last Name" required name="lastName" id="lastName" [formControl]="lastName">
          <small *ngIf="userForm.get('lastName').hasError('required') && userForm.get('lastName').touched">Required</small>
          <br>
          <label for="username">Username *</label>
          <br>
          <input *ngIf='action === "add"' placeholder="Enter Username" minlength="8" maxlength="60" type="text" required name="username" id="username" [formControl]="qID">
          <small *ngIf="userForm.get('qID').hasError('required') && userForm.get('qID').touched">Required</small>
          <small *ngIf="userForm.get('qID').hasError('pattern')">User name is not valid.</small>
          <div *ngIf='action === "edit"'>{{displayQID}}</div>
          <br>
          <label for="expirationDate">Account Expiration *</label>
          <br>
          <div>
            <input type="date" name="expirationDate" id="expirationDate" class="form-control" placeholder="YYYY-MM-DD" [formControl]="expirationDate" required />
          </div>
          <small *ngIf="userForm.get('expirationDate').hasError('required') && userForm.get('expirationDate').touched">Required</small>
          <br>
          <label for="address1">Address 1 *</label>
          <br>
          <input type="text" placeholder="Enter Address 1" required name="address1" id="address1" [formControl]="address1">
          <small *ngIf="userForm.get('address1').hasError('required') && userForm.get('address1').touched">Required</small>
          <br>
          <label for="address2">Address 2</label>
          <br>
          <input type="text" placeholder="Enter Address 2" name="address2" id="address2" [formControl]="address2">
          <br>
          <label for="city">City *</label>
          <br>
          <input type="text" placeholder="Enter City" required name="city" id="city" [formControl]="city">
          <small *ngIf="userForm.get('city').hasError('required') && userForm.get('city').touched">Required</small>
          <br>
          <label for="state">State/Province/Territory*</label>
          <br>
          <input type="text" placeholder="Enter State/Province/Territory" [formControl]="state" required name="state" id="state">
          <small *ngIf="userForm.get('state').hasError('required') && userForm.get('state').touched">Required</small>
          <br>
          <label for="zipCode">Zip/Postal Code*</label>
          <br>
          <input type="text" placeholder="Enter Zipcode" required name="zipCode" id="zipCode" [formControl]="zipCode">
          <small *ngIf="userForm.get('zipCode').hasError('required') && userForm.get('zipCode').touched">Required</small>
          <br>
          <label for="phone">Phone*</label>
          <br>
          <input type="text" placeholder="(___) ___-____" [imask]='{mask: phoneMask}' required name="phone" id="phone" [formControl]="phone">
          <br>
          <label for="email">Email*</label>
          <br>
          <input type="text" placeholder="someone@example.com" required name="email" id="email" [formControl]="email">
          <small *ngIf="userForm.get('email').hasError('required') && userForm.get('email').touched">Required</small>
          <small *ngIf="userForm.get('email').hasError('pattern')">Enter valid email</small>
          <br>
          <label for="reEnterEmail">Re-Enter Email*</label>
          <br>
          <input type="text" placeholder="someone@example.com" name="reEnterEmail" id="reEnterEmail" [formControl]="reEnterEmail">
          <small *ngIf="userForm.get('reEnterEmail').hasError('required') && userForm.get('reEnterEmail').touched">Required</small>
          <br>
          <label for="brandType">Brand Type *</label>
          <div>
            <select class="form-control" id="linemake" [formControl]='inputLinemake' required>
              <option *ngFor="let linemake of linemakes" [ngValue]="linemake">{{linemake}}</option>
            </select>
            <br>
          <small *ngIf="userForm.get('inputLinemake').hasError('required') && userForm.get('inputLinemake').touched">Required</small>
          </div>
          <div><small style="color: red">{{errorMessage}}</small></div>
          <div>
            <button type='submit' *ngIf='action === "add"' [disabled]='userForm.invalid' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
            class="bmw-submit-button" style="padding:7px;margin-top:70px">Add User</button>
            <button type='submit' *ngIf='action === "edit"' [disabled]='userForm.invalid' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
              class="bmw-submit-button" style="padding:7px;margin-top:70px" >Update User</button>
              <button [routerLink]='["/show-users"]' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
              class="bmw-submit-button" style="padding:7px;margin-top:15px">Back</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>